import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import NotificationService from '../../../core/services/NotificationService';
import { isRequired, isValidUrl } from '../../../core/validations';
import FileRepositoryTreeService from './FileRepositoryTreeService';

class FileRepositoryLinkService {
  form = new FormService();
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
      selectedAttachmentId: null,
    });
    this.form.validations = {
      title: [isRequired],
      url: [isRequired, isValidUrl],
    };
  }

  init = action(() => {
    this.form.reset();
    this.fetch.fetching = false;
    this.isOpen = false;
    this.selectedAttachmentId = null;
  });

  handleClose = action(() => {
    this.isOpen = false;
    this.selectedAttachmentId = null;
    this.form.reset();
  });

  handleToggleModal = (selectedAttachmentId) => {
    this.form.reset();
    this.isOpen = !this.isOpen;
    this.isEditing = false;
    this.selectedAttachmentId = selectedAttachmentId;
  };

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }

    this.submit = new FetchService();
    this.fetch
      .fetch({
        url: `/attachment-repositories/${this.selectedAttachmentId}/attach-link`,
        method: 'post',
        apiVersion: 'v3',
        body: this.form.getValues(),
      })
      .then(async () => {
        if (this.fetch.data) {
          FileRepositoryTreeService.load();
          NotificationService.addNotification('Link attached successfully.', 'success');
          this.handleToggleModal();
        }

        if (this.fetch.error) {
          NotificationService.addNotification('Error to attach link.', 'error');
        }
      });
  });
}

const fileRepositoryFileService = new FileRepositoryLinkService();

export default fileRepositoryFileService;
